import { createParamString } from 'common/baseFetch';

export const tidesFetchPath = (spotId: string, start?: string) =>
  `/kbyg/spots/forecasts/tides?${createParamString({ spotId, start })}`;
export const sunlightFetchPath = (spotId: string, start?: string) =>
  `/kbyg/spots/forecasts/sunlight?${createParamString({ spotId, start })}`;
export const spotReportFetchPath = (spotId: string) =>
  `/kbyg/spots/reports?${createParamString({ spotId })}`;
export const tideChartsPath = (spotId: string, spotSlug: string) =>
  `/tide-charts/${spotSlug}/${spotId}`;
export const fetchRegionalOverviewPath = (subregionId: string) =>
  `/kbyg/regions/overview?${createParamString({ subregionId })}`;
